import {createContext} from 'react';

import {DroppableContext} from './types';

export const droppableContext = createContext<DroppableContext | null>(null);
